import StopMeetingDialog from './StopMeetingDialog';

export default StopMeetingDialog;
